import React from 'react';
import cn from 'classnames';
import _isString from 'lodash/isString';
import styles from './index.module.scss';

import { ReactComponent as ErrorIcon } from 'assets/img/icons/new/error.svg';

/**
 * @param {Object} props
 * @param {string} [props.msg=''] - The error message to display.
 * @param {boolean} [props.hide=false] - Whether to hide the error message.
 * @param {string} [props.className=''] - Additional class names for styling.
 */
export default function Error({ msg = '', hide = false, className = '' }) {
  if (!msg || !_isString(msg) || hide) return null;

  return (
    <div className={cn(styles.container, className)}>
      <ErrorIcon />
      <span>{msg}</span>
    </div>
  );
}
